import React from 'react'
import { CompanyUserData } from '../../../../../../services/api/companies'
import { Table } from 'antd'

type Props = {
  users: CompanyUserData[]
}

export const View: React.FunctionComponent<Props> = ({ users }) => {
  return (
    <Table
      dataSource={users}
      size="small"
      columns={[
        {
          title: 'Email',
          dataIndex: 'email',
        },
        {
          title: 'Имя',
          render: (_, user) => `${user.firstName} ${user.lastName}`,
        },
      ]}
      pagination={false}
      rowKey={(user) => user.id}
    />
  )
}
